export default {
    getAllSDM17SPGs: () => {
        return {
            url: '/myfhe/SDM17SPGs',
            method: 'GET'
        };
    },
    getSDM17SPGDetails: SDM17SPGId => {
        return {
            url: '/myfhe/SDM17SPGs/:SDM17SPGId',
            method: 'GET',
            route_params: {
                SDM17SPGId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM17SPG/api.js